import { createContext, useContext, useEffect, useState } from "react";
import { AccountContext } from "./AccountContexts";
import { requestGuestPermissionsList, requestPermissionsList } from "../requests/general_requests";
import { loadingActive } from "../components/Background";
import { devLog } from "../utils/loggerUtils";




const PermissionContext = createContext()


const PermissionController = (props) => {

    const { user } = useContext(AccountContext)
    const [permissions, setPermissions] = useState([])

    useEffect(() => {
        loadingActive(true)
        if (user) {
            requestPermissionsList({})
                .then((data) => {
                    devLog("Loading " + user.rank + " permissions...")
                    setPermissions(data.permissions)
                    loadingActive(false)
                })
                .catch((error) => {
                    console.error(error.status, error.message)
                    loadingActive(false)
                })
        }
        else {
            requestGuestPermissionsList({})
                .then((data) => {
                    devLog("Loading guest permissions...")
                    setPermissions(data.permissions)
                    loadingActive(false)
                })
                .catch((error) => {
                    console.error(error.status, error.message)
                    loadingActive(false)
                })
        }
    }, [user])

    const hasPermission = (permission) => {
        return permissions.includes(permission)
    }

    return (
        <PermissionContext.Provider
            value={{
                permissions,
                hasPermission
            }}
        >
            {props.children}
        </PermissionContext.Provider>
    )
}


export { PermissionContext, PermissionController };